import React, { Component } from 'react';
import { Icon, TextField, Select, MenuItem, FormControl, InputLabel, Button, IconButton, Snackbar} from '@material-ui/core';
import Http from '../../Http';
import { withRouter } from "react-router-dom";
import SIDE_RESOURCES from '../Side/SideOptions';

const NAVBAR_RESOURCES = [
  {
    'type': 'children',
    'label': 'Configuracion del sistema',
    'parentLink': '/ConfiguracionSistema',
    'children': [
      { type: 'link', link: '/ConfiguracionSistema#correos', label: 'Correos' },
      { type: 'link', link: '/ConfiguracionSistema#usuarios', label: 'Usuarios' },
      { type: 'link', link: '/ConfiguracionSistema#cobros', label: 'Cobros' },
    ]
  }
]

const ACCIONES = [
  { "value": "create", label: "Crear" },
  { "value": "delete", label: "Eliminar" },
  { "value": "show", label: "Ver Todo" },
  { "value": "show_sucursal", label: "Ver Solo Sucursal" },
  { "value": "show_self", label: "Ver Propias" },
  { "value": "edit", label: "Editar Todo" },
  { "value": "edit_sucursal", label: "Editar Solo Sucursal del Usuario" },
  { "value": "edit_self", label: "Editar Solo del Usuario" },
];


class Rol extends Component {

  state = {
    nombreRol: "",
    acciones: ACCIONES,
    recursos: [],
    reglasEliminadas: [],
    reglashide: [],
    reglas: [
      {
        recurso: "",
        accion: "",
        parentLink: "",
      }
    ],
    snackbar: {
      open: false,
      message: '',
    },
    loading: false,
  }

  componentDidMount() {
    let resources = [...NAVBAR_RESOURCES, ...SIDE_RESOURCES];
    resources = JSON.parse(JSON.stringify(resources));
    const recursos = this.getSideResources({ resources })
    this.setState({ recursos });
    if (this.props.match.params.id) {
      this.LoadPreds(recursos)
    }
  }

  LoadPreds = async (recursos) => {
    let id = this.props.match.params.id;
    let Res = await Http.get(`usuario-rol/one/${id}`);
    if (!Res.error) {
      let { reglas } = Res.data;
      let reglasFil = reglas.filter(regl => recursos.some(rec => rec.link === regl.recurso) )
      let reglashide = reglas.filter(regl => !recursos.some(rec => rec.link === regl.recurso) )
      const reglasmap = reglasFil.map(regl => {
        const rec = recursos.find(rec => rec.link === regl.recurso)
        return { ...regl, acciones: rec.acciones }
      })
      this.setState({ nombreRol: Res.data.rol_nombre, reglas: reglasmap, reglashide, id: Res.data.id  });
    }
      //this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, true) })
  }

  getSideResources = ({ prefijo, resources, parentLink }) => {
    let sideResources = [];

    for (const resource of resources) {
      let pref = '';
      if (prefijo) {
        pref = `${prefijo}>${resource.label}`;
      } else {
        pref = resource.label
      }
      if (resource.type === "children") {
        sideResources.push(...this.getSideResources({ prefijo: pref, resources: resource.children, parentLink: resource.parentLink }));
      }

      if (resource.type === "link") {
        resource.label = prefijo ? `${prefijo}>${resource.label}` : resource.label;
        resource.parentLink = parentLink;
        sideResources.push(resource);
      }
    }
    return sideResources;
  }


  onValueChange = (name, value) => {
    this.setState({ [name]: value })
  }

  onReglaValueChange = (name, index, value) => {
    let { reglas, recursos } = this.state;
    if (name === "recurso") {
      const currentResource = recursos.find((recurso) => recurso.link === value);
      if (currentResource.parentLink) {
        reglas[index]['parentLink'] = currentResource.parentLink;
      } else {
        reglas[index]['parentLink'] = false;
      }
      if (currentResource.editlink) {
        reglas[index]['editlink'] = currentResource.editlink;
      }
      if (currentResource.acciones) {
        reglas[index]['acciones'] = currentResource.acciones;
      }
    }
    reglas[index][name] = value;
    this.setState({ reglas });
  }

  addRegla = () => {
    const { reglas } = this.state;
    reglas.push({ recurso: '', accion: '', parentLink: '' });
    this.setState({ reglas });
  }

  deleteRegla = (index, regla) => {
    let { reglas, reglasEliminadas, recursos, reglashide } = this.state;
    if (regla.id) {
      reglasEliminadas.push(regla);
    }
    
    if (['show', 'edit', 'show_all', 'redocumentar','show_sucursal', 
        'show_self', 'edit_all', 'edit_sucursal', 'edit_self', 'full_edit', 
        'full_cancel', 'print_precios', 'resend_email'].includes(regla.accion)) {
      const recurs = recursos.find(recurso => (recurso.link === regla.recurso));
      
      if (recurs && recurs.parentLink) {
        const parentRegla = reglashide.find(fr => (fr.recurso === recurs.editlink && fr.accion === regla.accion))
        if (parentRegla && parentRegla.id) {
          reglasEliminadas.push(parentRegla);
        }
      }
    }
    
    reglas = reglas.filter((regla, idx) => idx !== index);
    this.setState({ reglas, reglasEliminadas });
  }

  guardarRol = async () => {
    const { nombreRol, reglas, reglasEliminadas, id, reglashide } = this.state;
    this.setState({ loading: true })
    for (const regla of reglas) {
      if (regla.parentLink) {
        const exist = reglashide.some(reg => reg.recurso === regla.parentLink);
        if (!exist) {
          reglashide.push({ recurso: regla.parentLink, accion: "show" })
        }
      }
      if (regla.editlink && ['show', 'edit', 'print', 'redocumentar', 'show_all', 
      'show_sucursal', 'show_self', 'edit_all', 'edit_sucursal', 'edit_self', 
      'full_edit', 'full_cancel', 'print_precios', 'resend_email'].includes(regla.accion)) {
        
        const exist = reglashide.some(reg => reg.recurso === regla.editlink && reg.accion === regla.accion);
        if (!exist) {
          reglashide.push({ recurso: regla.editlink, accion: regla.accion })
        }
      }
    }
    let Res = await Http.post(`usuario-rol/save`, { nombreRol, reglas: [...reglas, ...reglashide], reglasEliminadas, id });
    if (!Res.error) {
      this.setState({ snackbar: { open: true, message: 'Guardado con exito', loading: false } })
      this.props.history.push('/RolesUsuario');
    } else {
      this.setState({ snackbar: { open: true, message: 'Ocurrio un error al guardar la informacion', loading: false } })
    }
  }

  render() {
    const { nombreRol, reglas, acciones, recursos, snackbar, loading } = this.state;
    return (
      <div style={{ margin: 10, padding: 10, backgroundColor: 'white' }} >
        <div className="row">
          <div className="col-sm-12">
            <h1>Rol</h1>
          </div>
          <div className="col-sm-12">
            <TextField
              value={nombreRol}
              onChange={(e) => { this.onValueChange("nombreRol", e.target.value) }}
              variant="outlined"
              label={'Nombre'}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <h1>Reglas</h1>
            <div>
              <Button
                variant="contained"
                onClick={this.addRegla}
                color='secondary'
                startIcon={<Icon>add</Icon>}
              >
                Agregar Regla
            </Button>
              <Button
                variant='contained'
                color='primary'
                onClick={this.guardarRol}
                disabled={loading}
              >
                Guardar
            </Button>

            </div>
          </div>
          {
            reglas.map((regla, index) => (
              <React.Fragment key={index} >
                <div className="col-5">
                  <FormControl variant="outlined" className='form-field'>
                    <InputLabel>Catalogo</InputLabel>
                    <Select
                      value={regla.recurso}
                      onChange={(e) => { this.onReglaValueChange(`recurso`, index, e.target.value) }} >
                      {
                        recursos.map((rec, index) => (
                          <MenuItem value={rec.link} key={`${rec}-${index}`} >{rec.label}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </div>
                <div className="col-5">
                  <FormControl variant="outlined" className='form-field'>
                    <InputLabel>Accion</InputLabel>
                    <Select
                      value={regla.accion}
                      onChange={(e) => { this.onReglaValueChange(`accion`, index, e.target.value) }} >
                      {
                        [...acciones, ...(regla.acciones || [])].map(accion => (
                          <MenuItem value={accion.value} key={accion.value} >{accion.label}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </div>
                <div className="col-2">
                  <IconButton onClick={() => { this.deleteRegla(index, regla) }} >
                    <Icon>remove_circle</Icon>
                  </IconButton>
                </div>
              </React.Fragment>
            ))
          }
        </div>
        
        {/* SNACKBAR MESSAGES */}
        <Snackbar
          open={snackbar.open}
          onClose={() => { this.setState({ snackbar: false }) }}
          autoHideDuration={6000}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{snackbar.message}</span>}
        />
      </div>
    )
  }
}

export default withRouter(Rol)